export const userQueryKeys = {
  all: ["users"] as const,
  current: () => [...userQueryKeys.all, "current"] as const,
  byId: (id: number) => [...userQueryKeys.all, "detail", id] as const,
  profile: () => [...userQueryKeys.all, "profile"] as const,
  blocked: () => [...userQueryKeys.all, "blocked"] as const,
};
